export default __webpack_public_path__ + "static/media/Group8894.31a3182d.svg";